import React from "react";

const Interview = ({ data }) => {
  if (!data) return null;
  return (
  <section id="interview" className="interview-section">
    <p className="section-index">02</p>
    <div className="interview-copy"><h2>{data.heading}</h2></div>
    <div className="video-container">
      <iframe title={data.videoTitle} src={data.videoEmbedUrl} frameBorder="0" loading="lazy" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
    </div>
  </section>
  );
};

export default Interview;
